<div class="row mb-2">
  <div class="col-md-6">
  </div>
 
 
  <div class="col-md-6  text-end">
    <button (click)="exportToExcel()" style="margin-right:5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
       Export Current Excel  </button>
       <button (click)="exportToExcel_allData()"   class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
        Export All Excel </button>
  </div>
</div>


<div class="main-card mb-3 card">
    <div class="card-header font-weight-B fs-1r">
      All Admin
    </div>
    <div class="table-responsive">
      <table class="align-middle mb-0 table table-borderless table-striped table-hover"  id="excel-table" >
        <thead>
        <tr>
          <!-- <th class="text-left" >#</th> -->
          <th> Username</th>
          <th>Admin Type</th>
          <th>Activation</th>
          <th class="text-end">Actions</th>
        </tr>
        </thead>
        <tbody>
        <!-- <tr *ngFor="let data of allAdmin | paginate: { itemsPerPage: 5, currentPage: p }"> -->
            <tr *ngFor="let data of allAdmin">
          <!-- <td class="text-left text-muted">#345</td> -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.userName}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.adminType}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
         
           <td >
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    <label class="switch">
                        <input type="checkbox" (ngModelChange)="setActivationAdmin($event , data)" [(ngModel)]="data.active" >
                        <span class="slider round"></span>
                      </label>
                  </div>
                </div>
              </div>
            </div>
          </td> 
         
          <td class="text-end">
            <div class="dropdown">
              <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                Action
              </button>
              
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li><a (click)="openModal(content1 , data)"   class="dropdown-item " >Edit <i class="fa fa-pencil"></i></a></li>
                <li ><a (click)="deleteAdmin(data)" class="dropdown-item"    >Delete <i class="fa fa-trash"></i></a></li>
              </ul>
            </div>
          </td>
        </tr>
       
        </tbody>
        <div *ngIf="allAdmin?.length  == 0" class="text-center mt-5 mb-5" >
          <span class="text-danger">Data Not found</span>
        </div>
        <!-- <pagination-controls class="my-pagination" (pageChange)="p = $event"></pagination-controls> -->
        
      </table>
    </div>
  </div>





  <div class="card-body">
    <ng-template #content1 let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title"> <i class="fa fa-pencil" aria-hidden="true"></i> Edit Admin   </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <label for="">ID : </label>
            <input type="text" [(ngModel)]="editAdminId"  [disabled]="true" class="form-control">
         </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="">Name / Username :</label>
            <input type="text" [(ngModel)]="adminName"  placeholder="Enter new password" class="form-control">
         </div>
        </div>
  
        <div class="row">
            <div class="col-md-12">
              <label for="">Admin Type : </label>
              <select name="" id=""  [(ngModel)]="adminType"  class="form-control" >
                <option value="">Select Admin Type</option>
                <option value="Super Admin">Super Admin</option>
                <option value="Sub Admin">Sub Admin</option>
                <option value="Editor">Editor</option>
              </select>
            </div>
          </div>
    
  
         <div class="row">
            <div class="col-md-12">
              <label for="">New Password :</label>
              <input type="text" [(ngModel)]="newPassword"  placeholder="Enter new password" class="form-control">
           </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <label for="">Confirm Password :</label>
              <input type="text" [(ngModel)]="confirmPassword"  placeholder="Enter confirm password" class="form-control">
           </div>
          </div>
          
          <div class="row mt-2 mb-2 text-center">
           <div class="col-md-12">
             <button (click)="updateAdmin()" [disabled]=" adminName == '' || adminType == ''" class="btn btn-primary btn-lg btn-block">Update Admin</button>
           </div>
         </div> 
  
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> -->
    </ng-template>
    <!-- <button class="btn btn-primary" (click)="open(content5)">Launch demo modal</button> -->
  </div>



